import Container, { ContainerProps } from '@mui/material/Container'
import { styled } from '@mui/material/styles'

export const AkhetContainer = styled(Container)<ContainerProps>(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'light' ? '#F5F5F6' : '#252525',
  boxShadow: theme.palette.mode === 'light' ? '#b9b9b9 0px 0px 20px 0px' : 'black 0px 0px 20px 0px',
  minHeight: '100vh'
}))
